<template>
  <div :id="gRecaptchaId"></div>
</template>
<script setup>
import { ref, onMounted, defineEmits, defineExpose } from 'vue'
import { useThemeStore } from '@/stores/theme'
import useLoadScript from '@/composables/useLoadScript'

const themeStore = useThemeStore()
const gRecaptchaId = ref()
const gRecaptchaWidget = ref()

const emits = defineEmits(['errorCallback', 'successCallback'])

const randomId = Math.floor(Math.random() * 1000)
gRecaptchaId.value = `g-recaptcha-${randomId}`

const gRecaptchaSuccessCallback = (args) => {
  emits('successCallback', args)
}
const gRecaptchaExpiredCallback = (args) => {
  emits('errorCallback', {
    type: 'expired',
    args
  })
}
const gRecaptchaErrorCallback = (args) => {
  emits('errorCallback', {
    type: 'error',
    args
  })
}

const initGRecaptcha = () => {
  gRecaptchaWidget.value = grecaptcha.render(gRecaptchaId.value, {
    sitekey: import.meta.env.VITE_RECAPTCHA_KEY,
    theme: themeStore.currentScheme,
    size: 'normal',
    callback: gRecaptchaSuccessCallback,
    'expired-callback': gRecaptchaExpiredCallback,
    'error-callback': gRecaptchaErrorCallback
  })
}

const validate = () => {
  try {
    const responseToken = grecaptcha?.getResponse(gRecaptchaWidget.value)
    grecaptcha.reset(gRecaptchaWidget.value)
    if (responseToken.length == 0) {
      return false
    } else {
      return responseToken
    }
  } catch (error) {
    console.error('grecaptcha validate error', error)
    return false
  }
}

onMounted(() => {
  useLoadScript(
    'https://www.recaptcha.net/recaptcha/api.js?onload=gronloadCallback&render=explicit',
    'google-recaptcha-script'
  )
  window['gronloadCallback'] = null
  window['gronloadCallback'] = () => {
    initGRecaptcha()
  }
})

defineExpose({ validate })
</script>
